export default __webpack_public_path__ + "static/media/analytics.a36bbf6f.gif";